var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.P_customClass},[_c(_vm.DV_componentType,{tag:"component"},[_vm._v(_vm._s(_vm.P_customCss))]),_vm._v(" "),_c('ControlProcessorNameLabel',{style:(_vm.textStyle),attrs:{"P_cpUid":("" + _vm.P_cpUid)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3931d213","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid/GDeviceName.vue
// module id = null
// module chunks = 